import { APP_CONFIG } from '../../utils/constants.js';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content flex align-center justify-between">
        <div className="footer-left">
          <span className="footer-text text-secondary">
            © {currentYear} {APP_CONFIG.NAME}. All rights reserved.
          </span>
        </div>
        
        <div className="footer-center flex justify-center">
          <nav className="footer-nav flex">
            {/* footer 내용 필요시 추가 */}
          </nav>
        </div>
        
        <div className="footer-right flex justify-end">
          <span className="version-text text-secondary">v{APP_CONFIG.VERSION}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 